import { ChangeDetectionStrategy, Component, Input, HostListener, ElementRef, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavbarComponent implements OnInit {
  @Input() logo = '';
  @Input() logoName = '';
  @Input() logoSlogan='';
  @Input() logoSloganMobile='';
  @Input() logoLink = '';

  @Input() links? : {
    text: string;
    link?: string;
    special: boolean;
    textOver?: string;
  }[]

  $open = new BehaviorSubject(false);

  constructor(private elRef: ElementRef){
    this.$open.next(false);
  }

  ngOnInit(): void {
    this.$open.next(false);
  }

  lastScrollTop = 0;
  $sticky = new BehaviorSubject(true);
  $logoPart = new BehaviorSubject('initial');

  openMenu() {
    if(window.innerWidth < 769){
    this.$open.next(!this.$open.value);

    this.$logoPart.next(this.$logoPart.value==='initial'?'hidden':'initial');
    this.elRef.nativeElement.children[0].style.backgroundColor=(this.$logoPart.value==='initial'?'rgba(255, 255, 255, .96)':'#fff');
    if(this.$open.value === true){
      document.body.classList.add('no-scroll');
    }else {
      document.body.classList.remove('no-scroll');
    }
  }
  else {
    this.$open.next(false);
  }
  }

  @HostListener('window:scroll')
  onScroll() {
    var st = window.pageYOffset || document.documentElement.scrollTop;
    if (st > this.lastScrollTop){
       if(this.$sticky.value){
        this.$sticky.next(false);
       }
    } else {
      if(!this.$sticky.value){
        this.$sticky.next(true);
       }
    }
    this.lastScrollTop = st <= 0 ? 0 : st;
  }
}
